<template>
  <c-card :color="headerColor">
    <h4 slot="title">{{ label }}</h4>
    <v-btn v-if="canRemove" icon slot="bar-actions" @click="$emit('remove',answer)">
      <v-icon>delete</v-icon>
    </v-btn>
    <smart-input textarea required :label="label" v-model="answer.content"></smart-input>
    <v-divider light></v-divider>
    <media-gallery v-if="media" @selected="selectedImage"/>
    <v-img :src="answer.media_src" max-width="75"></v-img>
  </c-card>
</template>

<script>
  import CCard from "dev/scaffoldings/cCard";
  import AddMedia from "root/packages/closeapp/QuestionsManager/assets/views/questions/AddMedia";
  import MediaGallery from "dev/packages/gallery/MediaGallery";

  export default {
    name: "answer-form",
    props: {
      answer: {type: Object, required: true},
      label: {default: "תשובה"},
      canRemove: {type: Boolean, default: true},
      media: {type: Boolean, default: false}
    },
    components: {MediaGallery, AddMedia, CCard},
    data() {
      return {
      };
    },
    computed: {
      headerColor() {
        if (this.label == "התשובה הנכונה") {
          return "success";
        } else if (this.label == "תשובה לא נכונה") {
          return "error";
        } else {
          return "#85afff";
        }
      }
    },
    methods: {
      selectedImage(img){
        this.$emit('updatedAnswerImage', img);
      }
    },
    watch: {},
    created() {
    },
    mounted() {
    },
    updated() {
    },
    destroyed() {
    }
  };
</script>

<style scoped>
.answer-image{

}
</style>
